/* Explicit offer URLs; no persistent flag changes the original storefront.
   config.view names the storefront (offer49 by default; built-in-lift for the Built-In Lift jeans). */
(() => {
  function route(value, config, current, preserveProduct = false) {
    if (!value || value.startsWith('#')) return value;
    const url = new URL(value, current);
    const here = new URL(current);
    if (url.origin !== here.origin) return value;
    const root = config.root.endsWith('/') ? config.root : `${config.root}/`;
    const path = decodeURIComponent(url.pathname);
    const product = new URL(config.product, current);
    const base = config.view || 'offer49';
    let view = base;
    if (path.includes('/products/')) {
      if (preserveProduct && path !== decodeURIComponent(product.pathname)) return value;
      if (path !== decodeURIComponent(product.pathname)) {
        url.pathname = product.pathname;
        url.searchParams.delete('variant'); // IDs belong to the original product.
      }
    } else if (path.includes('/policies/')) {
      view = `${base}-${path.split('/').pop()}`;
      if (!['shipping-policy','refund-policy','privacy-policy','terms-of-service'].map(name => `${base}-${name}`).includes(view)) return value;
      url.pathname = root;
    } else if (path.includes('/pages/')) {
      if (path.includes('/pages/contact')) view = `${base}-contact`;
    } else if (path.includes('/collections')) {
      url.pathname = `${root}collections/all`;
    } else if (path !== root && path !== `${root}search` && path !== `${root}cart`) {
      return value; // Checkout, account, API and external destinations stay native.
    } else if (url.searchParams.get('view')?.startsWith(`${base}-`)) {
      view = url.searchParams.get('view');
    }
    url.searchParams.set('view', view);
    const preview = here.searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return `${url.pathname}${url.search}${url.hash}`;
  }
  if (typeof module !== 'undefined') module.exports = route;
  if (typeof document === 'undefined') return;
  const configNode = document.getElementById('bl-offer-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  if (!config.product) return;
  window.blOfferURL = value => route(String(value), config, location.href);
  const updateLink = link => {
    const before = link.getAttribute('href');
    // A cart line is a real purchase selection, not a recommendation.
    const after = route(before, config, location.href, !!link.closest('.tc-cart-line,.cart-items__table-row'));
    if (after !== before) link.setAttribute('href', after);
  };
  const update = () => {
    document.querySelectorAll('a[href]').forEach(updateLink);
    document.querySelectorAll('form').forEach(form => {
      const path = new URL(form.action, location.href).pathname;
      if (path.endsWith('/search')) {
        let view = form.querySelector('[name=view]');
        if (!view) { view = document.createElement('input'); view.type = 'hidden'; view.name = 'view'; form.append(view); }
        view.value = config.view || 'offer49';
      }
      if (path.endsWith('/localization')) {
        const back = form.querySelector('[name=return_to]');
        if (back) back.value = `${location.pathname}${location.search}`;
      }
    });
  };
  update();
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; update(); });
  }).observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['href']});
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (link) updateLink(link);
  }, true);
})();
